import * as Safe from "safe-portals";
import { Serializers } from "@flow/common/types";

export type IntegrationConfig = Safe.TypeIn<typeof IntegrationConfigSerializer>;

export const IntegrationConfigSerializer = Safe.obj({
  url: Safe.str,
  credentials: Safe.str,
  contact_purpose_name: Safe.str,
});

export const ConfigTypeSerializer = Safe.versioned({
  schema: Safe.obj({
    list_id: Safe.int,
    name: Safe.str,
    on_no_target_msg_to_member: Safe.str,
  }),
  migrations: [
    (oldConfig) => ({ ...oldConfig, name: "" }),
    (oldConfig) => ({
      ...oldConfig,
      on_no_target_msg_to_member: "Sorry, it looks like your representative cannot be contacted on this issue.",
    }),
  ],
});

export const MembershipListConfigTypeSerializer = Safe.versioned({
  schema: Safe.array(Safe.obj({ membership_id: Safe.str, name: Safe.str, role: Safe.str })),
  migrations: [],
});

export const TargetLookupResultSerializer = Safe.variant(
  "target",
  Serializers.publicCampaignTarget,
  "insufficient_member_data",
  Safe.obj({}),
  "no_target",
  Safe.obj({})
);
export type TargetLookupResultType = Safe.TypeIn<typeof TargetLookupResultSerializer>;
